const userPreferencesActionTypes = {
  USER_PREFERENCES_SET_VALUE: 'USER_PREFERENCES_SET_VALUE',
};

export default userPreferencesActionTypes;
